import { get, post } from '@/utils/request'

const mapAPI = {
  mapApi: '/api/geo/map',
  chartmapApi: '/api/geo/chartmap',
  photoMarks: '/api/geo/photo/marks',
  photoMarksArea: '/api/geo/photo/marks_area',
  photoMarkInfo: '/api/geo/photo/mark/info'
}

export function addsMapMarks(jsonData) {
  return post(mapAPI.mapApi + '/marks', jsonData)
}

export function getMapMarks() {
  return get(mapAPI.mapApi + '/marks')
}

export function getPhotoMarks(areaCode) {
  return get(mapAPI.photoMarks + '?type=' + areaCode)
}

export function getPhotoMarksArea(areaCode) {
  return get(mapAPI.photoMarksArea + '?areaCode=' + areaCode)
}

export function getNearbyMarks(distance) {
  return get(mapAPI.mapApi + '/nearby?distance=' + distance)
}

export function getMarkerInfo(id) {
  return get(mapAPI.photoMarkInfo + '?id=' + id)
}

export function addGeoPath(data) {
  return post(mapAPI.mapApi + '/path', data)
}

export function getGeoPath(queryParam) {
  return get(mapAPI.mapApi + '/path', queryParam)
}

export function getChartMapGeojson(areaCode) {
  return get(mapAPI.chartmapApi + '/geojson?areaCode=' + areaCode)
}

export function getAreaCascadeOptions() {
  return get(mapAPI.chartmapApi + '/cascade')
}
